var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGyro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 30.1015L9.69995 19.5015L3 8.90148C11.7639 6.70016 20.9361 6.70016 29.7 8.90148L23 19.5015L16.3 30.1015Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3002 15.0013C14.46 15.0013 15.4002 14.0611 15.4002 12.9013C15.4002 11.7415 14.46 10.8013 13.3002 10.8013C12.1404 10.8013 11.2002 11.7415 11.2002 12.9013C11.2002 14.0611 12.1404 15.0013 13.3002 15.0013Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 15.4015C21.9387 15.4015 22.6998 14.6404 22.6998 13.7015C22.6998 12.7626 21.9387 12.0015 20.9998 12.0015C20.0609 12.0015 19.2998 12.7626 19.2998 13.7015C19.2998 14.6404 20.0609 15.4015 20.9998 15.4015Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3001 21.6017C17.239 21.6017 18.0001 20.8405 18.0001 19.9016C18.0001 18.9628 17.239 18.2017 16.3001 18.2017C15.3612 18.2017 14.6001 18.9628 14.6001 19.9016C14.6001 20.8405 15.3612 21.6017 16.3001 21.6017Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2998 7.60152C5.2998 6.46109 5.7528 5.36737 6.5592 4.56096C7.36561 3.75456 8.45936 3.3015 9.59979 3.3015C10.2024 3.2916 10.8001 3.41153 11.3522 3.6531C11.9044 3.89466 12.3981 4.25224 12.7998 4.70153V4.50152C12.7998 3.57326 13.1685 2.68301 13.8249 2.02663C14.4813 1.37025 15.3715 1.00152 16.2998 1.00152C16.7632 0.987674 17.2245 1.06874 17.6554 1.23974C18.0863 1.41073 18.4777 1.66803 18.8055 1.99584C19.1333 2.32364 19.3906 2.71503 19.5616 3.14593C19.7326 3.57682 19.8136 4.03814 19.7998 4.50152V4.70153C20.3974 4.06761 21.1698 3.62535 22.019 3.43084C22.8682 3.23632 23.756 3.29829 24.57 3.60888C25.384 3.91947 26.0874 4.46471 26.5912 5.1755C27.095 5.88628 27.3764 6.73063 27.3998 7.60152",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGyro);
export default __webpack_public_path__ + "static/media/gyro.4b6ad48fffafffdf967c5a54762ebfe2.svg";
export { ForwardRef as ReactComponent };